<div class="footer" fxLayout="row" fxLayoutAlign="space-evenly center" fxLayout.lt-lg="column"
     fxLayoutAlign.lt-lg="space-evenly center">
    <img src="assets/logo_footer.png" class="footer-logo" [alt]="'logo'|i18n">
    <span class="footer-text"><b>{{copyright}}</b></span>
    <span class="new-line">{{address}}</span>
</div>
